import { isZeroDecimalCurrency } from './isZeroDecimalCurrency';

export function amountToBaseUnits(amount: number, currency: string): number {
	return Math.round(isZeroDecimalCurrency(currency) ? amount : amount * 100);
}
